import styled from 'styled-components';

// Samsung
export const StyledSamsungCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const StyledSamsungCardImageBox = styled.div`
  margin-top: 240px;
  display: flex;
  justify-content: center;

  > img {
    width: 240px;
    height: 240px;
    border-radius: 8px;
    object-fit: cover;
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
  }
`;

export const StyledSamsungCardUserName = styled.div`
  display: flex;
  justify-content: center;
  font-weight: 500;
  font-size: 28px;
  margin-bottom: 85px;
`;

export const StyledSamsungCardContent = styled.div`
  display: flex;
  justify-content: start;
  padding-left: 280px;
  color: #454342;
  font-size: 28px;
`;

// GS
export const StyledGsCard = styled.div`
  position: relative;
  width: 100%;
`;

export const StyledGsCardImageBox = styled.div`
  position: absolute;
  top: 210px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;

  > img {
    width: 240px;
    height: 300px;
    border-radius: 8px;
    object-fit: contain;
    background-color: #f5f5f5;
    border: 1px solid #e0e0e0;
  }
`;

export const StyledGsCardContent = styled.div<{ top: number }>`
  position: absolute;
  left: 280px;
  top: ${({ top }) => `${top}px`};
  color: #454342;
  font-size: 32px;
`;
